import {
	FETCH_REPORTS_REQUEST,
	FETCH_REPORTS_SUCCESS,
	FETCH_REPORTS_FAIL,
} from "../constants/spinTheWheelReport";

function fetchSpinReportsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case FETCH_REPORTS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_REPORTS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				reports: action.payload,
			};
		case FETCH_REPORTS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export { fetchSpinReportsReducer };
